import {useContext} from "react";
import CommonContext from "../context/commonContext";

const useCommonContext = () => {
  return useContext(CommonContext);
};
export default useCommonContext;
